import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import Config from './config.js'

export default new Vuex.Store({
	state: {
		history: [],
		historyMessage: [],
		initSystem: false,
		loginSystem: false,
		clientSystem: null,
		period: []
	},
	mutations: {
		setHistory(state, history) { state.history.push(history)},
		setHistoryMessage(state, msg) { state.historyMessage.push(msg) },
		setInitSystem(state, val) { state.initSystem = val },
		setLoginSystem(state, val) { state.initSystem = val },
		setClientSystem(state, client) { state.clientSystem = client },
		setPeriod(state, period) { state.period = period },
	},
	actions: {
	},
	getters: {
		getHistoryMessage: state => { return state.historyMessage },
		getInitSystem: state => { return state.initSystem },
		getLoginSystem: state => { return state.initSystem },
		getClientSystem: state => { return state.clientSystem },
		getPeriod: state => { return state.period },
	},
	modules: {
		Config
	}
})
